import Phaser from 'phaser';
import { GameScene } from './scenes/GameScene';
import { GAME_WIDTH, GAME_HEIGHT } from './grid';
import { COLORS } from './colors';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: COLORS.bgOuter,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
  },
  scene: [GameScene],
  input: {
    activePointers: 3,
  },
  render: {
    antialias: true,
    roundPixels: false,
    pixelArt: false,
  },
};

const game = new Phaser.Game(config);
// Expose for debug / preview testing (harmless in production)
(window as any).__game = game;
